<template>
  <v-app>
    <v-app-bar
      id="appToolbar"
      app
      class="appToolbar"
      color="grey darken-3"
      dark
      dense
      fixed
      flat
    >
      <router-link :to="{name: 'Login'}">
        <v-avatar
          size="48"
          style="min-width: 48px;"
          tile
        >
          <svg-logo
            fork-color="#fff"
            pro-color="#fff"
            signal-color1="#fff"
            signal-color2="#fff"
            size="45px"
          />
        </v-avatar>
      </router-link>

      <v-divider
        class="ml-2"
        style="margin-left: 1px;"
        vertical
      />

      <v-toolbar-title class="ml-4 gfp-title-link font-weight-bold">
        <router-link :to="{name: 'Login'}">
          GETFOOD PRO
        </router-link>
      </v-toolbar-title>

      <v-spacer />
    </v-app-bar>

    <v-main>
      <slot />
    </v-main>

    <app-footer />
  </v-app>
</template>

<script>

import SvgLogo from '@/components/common/SvgLogo.vue'
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  name      : 'NoLayout',
  components: {
    AppFooter,
    SvgLogo
  },
  mixins: [],
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {}
}

</script>

<style scoped>
.gfp-title-link {
  color: #FFFFFF;
}

.gfp-title-link > a,
.gfp-title-link > a:link,
.gfp-title-link > a:visited,
.gfp-title-link > a:active {
  text-decoration: none !important;
  color: #FFFFFF !important;
}

.gfp-title-link > a:hover {
  text-decoration: none !important;
  color: #FFFFFF !important;
}
</style>
